/**
 * Eagerly registers the supported moment locales.
 *
 * Under webpack, moment's internal `require('./locale/' + name)` produced a
 * context module (pruned by the ContextReplacementPlugin in the prod
 * config), so locale data was bundled and `moment.locale('fr')` worked
 * lazily. Rspack does not follow moment's aliased require, so no locale
 * context is created — this shim (prepended to the procurify.app.init
 * entry) recreates one explicitly. The template string below makes Rspack
 * bundle `moment/locale/*`, which the ContextReplacementPlugin prunes to
 * the same locale set the webpack build shipped.
 */
const moment = require('moment')

// Mirrors the ContextReplacementPlugin regex in rspack.prod.config.js
// ('en' is built into moment; moment ships no 'en-us' locale file).
const SUPPORTED_LOCALES = [
  'en-au',
  'en-ca',
  'en-gb',
  'fr',
  'es',
  'es-us',
  'de',
  'nl',
  'pt-br',
]

SUPPORTED_LOCALES.forEach((locale) => {
  require(`moment/locale/${locale}`)
})

// Registering a locale makes it active — restore the default.
moment.locale('en')
